import { useEffect } from 'react';

import { BOOTSTRAP_ROUTER } from '@iwRouter/IwRouter.actions';
import { isLinkingOpenBankingOnly } from '@iwRouter/LocationHelper';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import styles from './MyAccount.module.css';
import IwModals from '../iwModals/IwModals';
import Navigation from './navigation/Navigation';
import { useNavVisibility } from './navigation/useNavVisibility';
import MainContent from './pageStructure/mainContent/MainContent';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    bootstrapRouter: () => dispatch({ type: BOOTSTRAP_ROUTER })
});

const MyAccount = ({
    bootstrapRouter
}: ReturnType<typeof mapDispatchToProps>) => {
    const { showNav } = useNavVisibility();

    const linkingOpenBankingOnly = isLinkingOpenBankingOnly();
    useEffect(() => {
        bootstrapRouter();
    }, [bootstrapRouter]);

    return (
        <div className={styles.MyAccount}>
            {!linkingOpenBankingOnly && showNav && <Navigation />}
            <div className={styles.contentContainer}>
                <MainContent />
            </div>
            <IwModals />
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(MyAccount);
